import moment from "moment";
import XLSX from "xlsx";
import _ from "lodash";

const history_trend_options = {
  chart: {
    type: "spline",
    zoomType: "xy"
  },
  title: { text: "" },
  subtitle: { text: "" },
  credits: {
    enabled: false // 禁用版权信息
  },
  plotOptions: {
    series: {
      states: {
        inactive: {
          opacity: 1
        }
      },
      connectNulls: true
    }
  },
  xAxis: {
    type: "datetime",
    dateTimeLabelFormats: {
      millisecond: "%H:%M:%S.%L",
      second: "%H:%M:%S",
      minute: "%H:%M",
      hour: "%H:%M",
      day: "%m-%d",
      week: "%m-%d",
      month: "%Y-%m",
      year: "%Y"
    }
  },
  yAxis: {
    title: {
      text: ""
    },
    min: 0
  },
  tooltip: {
    shared: true,
    crosshairs: true,
    dateTimeLabelFormats: {
      second: "%Y-%m-%d %H:%M:%S",
      minute: "%Y-%m-%d %H:%M:%S",
      hour: "%Y-%m-%d %H:%M:%S",
      day: "%Y-%m-%d %H:%M:%S",
      week: "%Y-%m-%d %H:%M:%S",
      month: "%Y-%m-%d %H:%M:%S",
      year: "%Y-%m-%d %H:%M:%S"
    },
    formatter: function() {
      let str = "";
      let p = this.points[0];
      const time_type = p.point.series.userOptions.time_type;
      const data_type = p.point.series.userOptions.data_type;
      const cur_info = G_SENSOR_DATA_TYPE_INFO.find(x => x.value == data_type);
      switch (time_type) {
        case "sec":
          str = moment(p.x).format("YYYY-MM-DD HH:mm:ss");
          break;
        case "min":
          str = moment(p.x).format("YYYY-MM-DD HH:mm");
          break;
        case "hour":
          str = moment(p.x).format("YYYY-MM-DD HH时");
          break;
        case "day":
        case "week":
        case "month":
        case "year":
          str = moment(p.x).format("YYYY-MM-DD");
          break;
      }
      str += "<br>";
      for (let item of this.points) {
        const is_water_V = item.series.userOptions.is_water_V;

        let val = item.y;
        if (!is_water_V) {
          str += `<span style="color:${item.color}">${item.series.name}(${
            cur_info.label
          })</span> : <span>${colorIntensity.sensortypeRound(data_type, val)} ${
            cur_info.unit
          }</span><br>`;
        } else {
          str += `<span style="color:${item.color}">${item.series.name}(${cur_info.label})</span> : <span>${val}</span><br>`;
        }
      }
      return str;
    }
  },
  series: [],
  exporting: {
    menuItemDefinitions: {
      downloadCSV: {
        onclick: function() {
          if (!this.userOptions.series.length) {
            return;
          }
          let content = "";
          const data_type = this.userOptions.series[0].data_type;
          // 时间去重排序
          let timeList = _.orderBy(
            _.uniq(
              this.userOptions.series
                .map(x => x.data)
                .flat()
                .map(y => y[0])
            )
          );
          content = `日期,${this.userOptions.series
            .map(x => x.name)
            .join(",")} \n`;
          for (const t of timeList) {
            const text = [];
            this.userOptions.series.forEach(x => {
              const info = x.data.find(y => y[0] == t);
              const is_water_V = x.is_water_V;
              if (is_water_V) {
                text.push(info[1]);
              } else {
                if (info) {
                  text.push(
                    `${colorIntensity.sensortypeRound(data_type, info[1])}\t`
                  );
                } else {
                  text.push("");
                }
              }
            });
            content += `${moment(t).format("YYYY-MM-DD HH:mm")},${text.join(
              ","
            )} \n`;
          }
          // 创建 Blob 对象
          let blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), content], {
            type: "text/csv;charset=utf-8;"
          });

          // 创建下载链接
          let link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${this.userOptions.title.text}.csv`;
          link.style.display = "none";

          // 添加链接到文档中并触发下载
          document.body.appendChild(link);
          link.click();

          // 清理
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
        }
      },
      downloadXLS: {
        onclick: function() {
          if (!this.userOptions.series.length) {
            return;
          }
          let processedData = [];
          const data_type = this.userOptions.series[0].data_type;
          // 时间去重排序
          let timeList = _.orderBy(
            _.uniq(
              this.userOptions.series
                .map(x => x.data)
                .flat()
                .map(y => y[0])
            )
          );
          processedData.push(
            ["日期"].concat(this.userOptions.series.map(x => x.name))
          );
          for (const t of timeList) {
            let content = [];
            this.userOptions.series.forEach(x => {
              const info = x.data.find(y => y[0] == t);
              const is_water_V = x.is_water_V;
              if (is_water_V) {
                content.push(info[1]);
              } else {
                if (info) {
                  content.push(
                    colorIntensity.sensortypeRound(data_type, info[1])
                  );
                } else {
                  content.push("");
                }
              }
            });
            processedData.push(
              [moment(t).format("YYYY-MM-DD HH:mm")].concat(content)
            );
          }
          // 将数据转换为工作表
          let worksheet = XLSX.utils.json_to_sheet(processedData, {
            skipHeader: true
          });
          let workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            this.userOptions.title.text
          );
          XLSX.writeFile(workbook, `${this.userOptions.title.text}.xlsx`);
        }
      }
    },
    buttons: {
      contextButton: {
        menuItems: [
          "printChart",
          "separator",
          "downloadCSV",
          "downloadXLS",
          "separator",
          "downloadPNG",
          "downloadJPEG",
          "downloadPDF",
          "downloadSVG"
        ]
      }
    }
  },
  responsive: {
    rules: [
      {
        condition: { maxWidth: 500 },
        chartOptions: {
          legend: {
            layout: "horizontal",
            align: "center",
            verticalAlign: "bottom"
          }
        }
      }
    ]
  }
};

const online_rate_options = {
  chart: {
    type: "spline",
    zoomType: "x"
  },
  rangeSelector: {
    enabled: false
  },
  credits: {
    enabled: false // 禁用版权信息
  },
  title: {
    text: "在线小时数"
  },
  subtitle: {
    text: "根据自有设备数据绘制"
  },
  exporting: {
    filename: "数据",
    csv: {
      dateFormat: "%Y-%m-%d"
    }
  },
  loading: {
    hideDuration: 1000,
    showDuration: 1000
  },
  xAxis: {
    type: "datetime",
    title: {
      enabled: true,
      text: "日期"
    },
    labels: {
      formatter: function() {
        return moment(this.value).format("MM-DD");
      }
    },
    dateTimeLabelFormats: {
      millisecond: "%H:%M:%S.%L",
      second: "%H:%M:%S",
      minute: "%H:%M",
      hour: "%H:%M",
      day: "%m-%d",
      week: "%m-%d",
      month: "%Y-%m",
      year: "%Y"
    },
    showLastLabel: true
  },
  yAxis: {
    visible: true,
    title: {
      margin: 40,
      text: "小时"
    },
    labels: {
      align: "right",
      x: 30,
      y: 3,
      formatter: function() {
        return this.value;
      }
    },
    lineWidth: 2
  },
  navigator: {
    xAxis: {
      type: "datetime",
      labels: {
        formatter: function() {
          return moment(this.value).format("YYYY-MM-DD");
        }
      },
      dateTimeLabelFormats: {
        millisecond: "%H:%M:%S.%L",
        second: "%H:%M:%S",
        minute: "%H:%M",
        hour: "%H:%M",
        day: "%m-%d",
        week: "%m-%d",
        month: "%Y-%m",
        year: "%Y"
      }
    }
  },
  legend: {
    enabled: true
  },
  tooltip: {
    shared: true,
    split: false,
    xDateFormat: "%Y-%m-%d"
  },
  series: []
};

const patrol_chart_options = {
  chart: {
    type: "spline",
    zoomType: "x",
    marginTop: 64
  },
  rangeSelector: {
    enabled: false
  },
  credits: {
    enabled: false // 禁用版权信息
  },
  title: {
    text: ""
  },
  exporting: {
    enabled: false
  },
  xAxis: {
    type: "datetime",
    labels: {
      formatter: function() {
        return moment(this.value).format("HH:mm");
      }
    },
    dateTimeLabelFormats: {
      millisecond: "%H:%M:%S.%L",
      second: "%H:%M:%S",
      minute: "%H:%M",
      hour: "%H:%M",
      day: "%m-%d",
      week: "%m-%d",
      month: "%Y-%m",
      year: "%Y"
    },
    showLastLabel: true
  },
  yAxis: {
    visible: true,
    title: {
      text: ""
    },
    min: 0,
    lineWidth: 2
  },
  navigator: {
    xAxis: {
      type: "datetime",
      labels: {
        formatter: function() {
          return moment(this.value).format("YYYY-MM-DD HH:mm:ss");
        }
      },
      dateTimeLabelFormats: {
        millisecond: "%H:%M:%S.%L",
        second: "%H:%M:%S",
        minute: "%H:%M",
        hour: "%H:%M",
        day: "%m-%d",
        week: "%m-%d",
        month: "%Y-%m",
        year: "%Y"
      }
    }
  },
  legend: {
    enabled: false
  },
  tooltip: {
    shared: true,
    split: false,
    xDateFormat: "%Y-%m-%d",
    formatter: function() {
      let str = "";
      let p = this.points[0];
      const data_type = p.point.series.userOptions.data_type;
      const cur_info = G_SENSOR_DATA_TYPE_INFO.find(x => x.value == data_type);
      str += moment(p.x).format("MM-DD HH:mm:ss");
      str += "<br>";
      for (let item of this.points) {
        const is_water_V = item.series.userOptions.is_water_V;

        let val = item.y;
        if (!is_water_V) {
          str += `<span style="color:${item.color}">${item.series.name}(${
            cur_info.label
          })</span> : <span>${colorIntensity.sensortypeRound(data_type, val)} ${
            cur_info.unit
          }</span><br>`;
        } else {
          str += `<span style="color:${item.color}">${item.series.name}(${cur_info.label})</span> : <span>${val}</span><br>`;
        }
      }
      return str;
    }
  },
  series: []
};

export { history_trend_options, online_rate_options, patrol_chart_options };
